import Alpine from 'alpinejs'
import intersect from '@alpinejs/intersect'
import Swup from 'swup';
import SwupPreloadPlugin from '@swup/preload-plugin';

window.lazySizesConfig = window.lazySizesConfig || {};
window.lazySizesConfig.init = false;

Alpine.plugin(intersect);
window.Alpine = Alpine;
Alpine.start();

const body = document.body;
const select = e => document.querySelector(e);
const selectAll = e => document.querySelectorAll(e);

const swup = new Swup({
    animationSelector: '[class*="page-transition-"]',
    plugins: [new SwupPreloadPlugin()]
});

init();

function init() {
    if (document.body.clientWidth > 1191) {
        setTimeout(function() {
            headerScroll();
        }, 100);
    }
}

let pageChangingEvent = new Event("pageChanging");
let pageChangedEvent = new Event("pageChanged");
let scrollPositionEvent = new Event("scrollPosition");

function headerScroll() {
    var scrollPos = 0;
    // adding scroll event
    document.getElementById('header').classList.remove('!-translate-y-full');

    window.addEventListener('scroll', function(){
    // detects new state and compares it with the new one
    if ((document.body.getBoundingClientRect()).top > scrollPos) {
            document.getElementById('header').classList.remove('!-translate-y-full');
    } else {
        if( window.scrollY <= 0 ){
            return;
        } else {
            document.getElementById('header').classList.add('!-translate-y-full');
        }
    }
        // saves the new position for iteration.
        scrollPos = (document.body.getBoundingClientRect()).top;
    });

}

swup.on('pageLoaded', function () {
  init();
  window.dispatchEvent(new Event('resize'));
});

swup.on('animationOutStart', function () {
    console.log('changing');
    document.dispatchEvent(pageChangingEvent);
});

swup.on('contentReplaced', function () {
    console.log('done');
    window.scrollTo(0, 0);
    document.dispatchEvent(pageChangingEvent);
    init();
});
